import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './BusinessTravel.css';
import Heading from '../../../utls/Heading';

const BusinessTravel = () => {
  return (
    <>
        <div className="container  EmpoweringSection ">
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                    <Heading className='headings  text-center'><span>Global Network </span>for Effortless Business Travel</Heading>
                    <p className='firstPara mt-2 mt-md-4 grotesk-headings'>Travel the world from any part of the world! Blueberry Travel provides innovative and cost-effective travel management solutions to the corporate market. Our commitment is to provide personalized travel solutions that deliver results in every market, large and small. We take pride in our extensive global network, which allows us to offer world-class travel management services globally.</p>
                    <p className='secondPara grotesk-headings'>We take great pleasure in offering seamless and reliable solutions—whether that means planning a trip locally or around the globe, we are your dedicated global partner in travel management services! Our global travel management services open doors to some of the most captivating locations and experiences across the globe, whether for business travel, education abroad studies, sports adventures, or general leisure—making your experience seamless and unforgettable!
                    </p>
                    <p className='secondPara grotesk-headings'>Blueberry Travel can be your global travel partner and help make sure all your dreams of global adventures become a reality. Let us be part of your global adventures today.</p>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default BusinessTravel;